class Countdown {

  publishTime = null;

  daysSpan = null;
  hoursSpan = null;
  minutesSpan = null;
  secondsSpan = null;

  counter = null;

  init() {
    let clock = document.getElementById('ns-countdown');
    this.daysSpan = clock.querySelector('.days');
    this.hoursSpan = clock.querySelector('.hours');
    this.minutesSpan = clock.querySelector('.minutes');
    this.secondsSpan = clock.querySelector('.seconds');
		if (clock.dataset.time !== undefined && null !== clock.dataset.time && '' !== clock.dataset.time.trim()) {
      let dateTimeParts = clock.dataset.time.split(/[- :]/); // split date string into array with: year, month, day, hour, minutes, seconds
      dateTimeParts[1]--; // monthIndex begins with 0 for january so we need to decrement by one
      this.publishTime = new Date(Date.UTC(...dateTimeParts)); // automatically converted to Browser timezone
      this.updateClock();
      this.counter = setInterval(() => {
        this.updateClock();
      }, 1000);
    } else {
      this.daysSpan.innerHTML = '0';
      this.hoursSpan.innerHTML = '0';
      this.minutesSpan.innerHTML = '0';
      this.secondsSpan.innerHTML = '0';
    }
  }


  updateClock() {
    const t = this.getTimeRemaining();
    this.daysSpan.innerHTML = t.days;
    this.hoursSpan.innerHTML = ('0' + t.hours).slice(-2);
    this.minutesSpan.innerHTML = ('0' + t.minutes).slice(-2);
    this.secondsSpan.innerHTML = ('0' + t.seconds).slice(-2);
    if (t.diff <= 0) {
      clearInterval(this.counter);
      setTimeout(() => {
        location.reload();
      }, 5000);
    }
  }


  getTimeRemaining() {
    const diff = Date.parse(this.publishTime) - Date.parse(new Date());
    const seconds = Math.floor((diff / 1000) % 60);
    const minutes = Math.floor((diff / 1000 / 60) % 60);
    const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    return {
      diff,
      days,
      hours,
      minutes,
      seconds
    };
  }


}

export default new Countdown();
